module.exports = __webpack_public_path__ + "static/media/zapier.97196037.svg";